const getQuery = (query) => {
  const { page, limit, dateFrom, dateTo, status, location, name, jobPosition, sortByStatus } = query
  const fromTs = dateFrom ? Date.UTC(dateFrom.getFullYear(), dateFrom.getMonth(), dateFrom.getDate()) : null
  const toTs = dateTo ? Date.UTC(dateTo.getFullYear(), dateTo.getMonth(), dateTo.getDate()) : null
  const queryText =
    `page=${page}&limit=${limit}` +
    (fromTs != null ? `&from=${fromTs}` : '') +
    (toTs != null ? `&to=${toTs}` : '') +
    (name ? `&name=${name}` : '') +
    (location ? `&location=${location}` : '') +
    (jobPosition ? `&jobPosition=${jobPosition}` : '') +
    (status ? (status !== 'all' ? `&status=${status}` : '') : '') +
    (sortByStatus ? '&sortByStatus=true' : '')

  return queryText
}

export default getQuery
